export default __webpack_public_path__ + "static/media/shop.4b8cdccf.svg";